"use strict";

angular.module("core")
.service("PreviousStateService", function($rootScope) {
    var previousState;

    this.init = function() {
        previousState = {
            name: "home",
            params: null
        };
    };

    this.getPreviousState = function() {
        return previousState;
    };

    $rootScope.$on("$stateChangeStart", function(event, toState, toParams, fromState, fromParams) {
        if (fromState.name !== "") {
            previousState.name = fromState.name;
            previousState.params = fromParams;
        }
    });
});



//////////////////
// WEBPACK FOOTER
// ./core/previous-state/previous-state.service.js
// module id = 882
// module chunks = 0